import React from 'react';
import { XCircle, Thermometer } from 'lucide-react';
import { FadeIn } from '../ui/FadeIn';
export function Problem() {
  const failures = ['Los suplementos "naturales" fallan porque tu cuerpo no puede absorberlos si tus niveles de estrés están disparados.', 'Las dietas de pocas calorías cierran tu metabolismo y empeoran los sofocos por falta de nutrientes clave.', 'Ejercicios intensos después de los 45 años elevan el cortisol, lo que te hace acumular más grasa abdominal.', 'Ignorar el ciclo de 16 horas impide que tu cuerpo realice la reparación hormonal necesaria durante el sueño.'];
  return <section className="py-20 md:py-32 px-4 bg-white" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-137">
          {/* Left Column: The Problem */}
          <div data-id="element-138">
            <FadeIn data-id="element-139">
              <div className="w-12 h-12 bg-brand-errorLight rounded-full flex items-center justify-center mb-6" data-id="element-140">
                <Thermometer className="w-6 h-6 text-brand-error" data-id="element-141" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-dark" data-id="element-142">
                Tu metabolismo se ha convertido en una montaña rusa
              </h2>
              <div className="space-y-4 text-lg text-brand-dark/80 leading-relaxed" data-id="element-143">
                <p data-id="element-144">
                  La menopausia y la perimenopausia han cambiado las reglas del
                  juego. La ropa que antes te quedaba perfecta ahora te aprieta
                  en el abdomen.
                </p>
                <p data-id="element-145">
                  Los sofocos aparecen en el momento menos oportuno y el
                  insomnio se ha vuelto tu compañero constante.
                </p>
                <p data-id="element-146">
                  Has intentado dietas restrictivas que solo te estresan más,
                  suplementos costosos que no hacen nada y consejos genéricos de
                  personas que no entienden lo que es sentir que tu termostato
                  interno se ha roto.
                </p>
                <p className="font-medium text-brand-dark" data-id="element-147">
                  El problema es que esas soluciones no atacan la raíz: el pico
                  de cortisol nocturno y la inflamación celular.
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Right Column: Why it didn't work */}
          <div data-id="element-148">
            <FadeIn delay={0.2} data-id="element-149">
              <div className="bg-brand-beige p-8 md:p-10 rounded-3xl border border-brand-lavenderLight" data-id="element-150">
                <h3 className="text-2xl font-bold mb-8 text-brand-dark" data-id="element-151">
                  Por qué lo que has intentado no funciona
                </h3>
                <ul className="space-y-6" data-id="element-152">
                  {failures.map((text, index) => <li key={index} className="flex items-start gap-4" data-id="element-153">
                      <XCircle className="w-6 h-6 text-brand-error flex-shrink-0 mt-1" data-id="element-154" />
                      <span className="text-brand-dark/80 leading-relaxed" data-id="element-155">
                        {text}
                      </span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}